/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Input types
 */
export enum Inputs {
    CITY = 'city',
    STREET = 'street',
    NUMBER = 'number',
}

/**
 * Form input types
 */
export const enum FormInputType {
    CONTROL = 'control',
    ELEMENT_BLOCK = 'element_block',
}

/**
 * AVC Actions
 */
export enum AvcAction {
    CHECK_SEAMLESS_AVAILABILITY = 'CABLE/AVC/CHECK_SEAMLESS_AVAILABILITY',
    SET_ERROR = 'CABLE/AVC/SET_ERROR',
    SET_INPUT = 'CABLE/AVC/SET_INPUT',
    SET_SELECTED_ADDRESS = 'CABLE/AVC/SET_SELECTED_ADDRESS',
    SET_ADDRESSES = 'CABLE/AVC/SET_ADDRESSES',
    CHECK_ADDRESS = 'CABLE/AVC/CHECK_ADDRESS',
    CHECK_LOGGED_IN = 'CABLE/AVC/CHECK_LOGGED_IN',
    RESET_FORM = 'CABLE/AVC/RESET_FORM',
}
